import React, { useMemo } from 'react';
import styles from './styles.module.css';
import { Icon } from 'common/icon';

type StarRatingProps = {
  ratingNumber: string; // e.g. "3.5"
  starSize: string; // e.g. "24px"
  color: string; // e.g. "#FFBB00"
  starGap?: string; // optional gap between stars
};

export const StarRating = ({
  ratingNumber,
  starSize,
  color,
  starGap = '4px',
}: StarRatingProps) => {
  const rating = parseFloat(ratingNumber);

  const starsArray = useMemo(() => Array.from({ length: 5 }), []);

  return (
    <div className={styles.stars} style={{ gap: starGap }}>
      {starsArray.map((_, index) => {
        const fillFactor = Math.min(1, Math.max(0, rating - index));

        return (
          <div
            key={index}
            className={styles.starWrapper}
            style={{ width: starSize, height: starSize }}
          >
            <Icon.Star
              fill={color}
              fillOpacity={0.25}
              width={starSize}
              height={starSize}
            />

            <div
              className={styles.partialFill}
              style={{ width: `${fillFactor * 100}%` }}
            >
              <Icon.Star fill={color} width={starSize} height={starSize} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
